export default __webpack_public_path__ + "static/media/salmon.88a6cb53.png";